import { render, staticRenderFns } from "./index-carousel.vue?vue&type=template&id=33fde30c&scoped=true&"
import script from "./index-carousel.vue?vue&type=script&lang=js&"
export * from "./index-carousel.vue?vue&type=script&lang=js&"
import style0 from "./index-carousel.vue?vue&type=style&index=0&id=33fde30c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fde30c",
  null
  
)

export default component.exports